/**
 * シーン遷移管理
 *
 * switchToSceneTop                      - TOP（トップ）  ※初期表示
 * switchToScenePayoutRequestTop         - PAYOUT_REQUEST_TOP（出金依頼）
 * switchToScenePayoutRequestHistory     - PAYOUT_REQUEST_HISTORY（出金履歴）
 * switchToScenePayoutRequestConfirm     - PAYOUT_REQUEST_CONFIRM（出金確認）
 * switchToSceneHarvestTop               - HARVEST_TOP（収穫実績トップ）
 * switchToSceneHarvestHistory            - HARVEST_HISTORY（収穫残高履歴）
 * switchToSceneHarvestEstimatedReturn   - HARVEST_ESTIMATED_RETURN（収穫予定一覧）
 */
import { Scenes } from "../constants";

export const SceneNavigationMixin = {
  // === シーン切り替えメソッド ===

  switchToSceneTop(options = {}) {
    this._switchScene(this.sceneTopTarget, Scenes.TOP, options);
    // Reset payout request state (called in both cancel and back button)
    this.resetPayoutRequestState();
  },

  switchToScenePayoutRequestTop(options = {}) {
    this._switchScene(this.scenePayoutRequestTopTarget, Scenes.PAYOUT_REQUEST_TOP, options);
    this.initializePayoutRequestState();
  },

  switchToScenePayoutRequestHistory() {
    this._switchScene(this.scenePayoutRequestHistoryTarget, Scenes.PAYOUT_REQUEST_HISTORY);
  },

  switchToScenePayoutRequestConfirm() {
    this._switchScene(this.scenePayoutRequestConfirmTarget, Scenes.PAYOUT_REQUEST_CONFIRM);
  },

  switchToSceneHarvestTop() {
    this._switchScene(this.sceneHarvestTopTarget, Scenes.HARVEST_TOP);
  },

  switchToSceneHarvestHistory() {
    this._switchScene(this.sceneHarvestHistoryTarget, Scenes.HARVEST_HISTORY);
  },

  switchToSceneHarvestEstimatedReturn() {
    this._switchScene(this.sceneHarvestEstimatedReturnTarget, Scenes.HARVEST_ESTIMATED_RETURN);
    this.fetchAndPopulateEstimatedReturnTabs();
  },

  // === 戻るボタン ===

  /**
   * 戻るボタンのロジック
   *
   * 戻り先マップ:
   * - TOP                    → mypage（リダイレクト）
   * - PAYOUT_REQUEST_TOP     → TOP
   * - PAYOUT_REQUEST_HISTORY → PAYOUT_REQUEST_TOP
   * - PAYOUT_REQUEST_CONFIRM → PAYOUT_REQUEST_TOP
   * - HARVEST_TOP            → TOP
   * - HARVEST_HISTORY         → HARVEST_TOP
   * - HARVEST_ESTIMATED_RETURN  → HARVEST_TOP
   */
  goBack() {
    switch (this.currentSceneValue) {
      case Scenes.TOP:
        window.location.href = this.mypagePathValue;
        break;

      case Scenes.PAYOUT_REQUEST_TOP:
        this.switchToSceneTop();
        break;

      case Scenes.PAYOUT_REQUEST_CONFIRM:
        this.switchToScenePayoutRequestTop();
        break;

      case Scenes.PAYOUT_REQUEST_HISTORY:
        this.switchToScenePayoutRequestTop();
        break;

      case Scenes.HARVEST_TOP:
        this.switchToSceneTop();
        break;

      case Scenes.HARVEST_HISTORY:
      case Scenes.HARVEST_ESTIMATED_RETURN:
        this.switchToSceneHarvestTop();
        break;

      default:
        this.switchToSceneTop();
    }
  },

  // === ヘルパーメソッド（内部実装） ===

  /**
   * シーン切り替え共通処理
   * @param {HTMLElement} sceneTarget - 表示するシーン要素
   * @param {string} sceneValue - Scenes定数の値
   * @param {Object} [options] - オプション
   * @param {string} [options.notification] - 通知タイプ（指定時はシーン会話テキストの代わりに通知を表示）
   */
  _switchScene(sceneTarget, sceneValue, { notification } = {}) {
    this._hideAllScenes();
    sceneTarget.style.display = "block";
    this._addFadeIn(sceneTarget);
    this.currentSceneValue = sceneValue;
    this.updateFooterDialogueText(notification);
    this.updateHeaderTitle();
  },

  _hideAllScenes() {
    this.sceneTopTarget.style.display = "none";
    this.scenePayoutRequestTopTarget.style.display = "none";
    this.scenePayoutRequestHistoryTarget.style.display = "none";
    this.scenePayoutRequestConfirmTarget.style.display = "none";
    this.sceneHarvestTopTarget.style.display = "none";
    this.sceneHarvestHistoryTarget.style.display = "none";
    this.sceneHarvestEstimatedReturnTarget.style.display = "none";
  },

  _addFadeIn(element) {
    element.style.opacity = "0";
    element.style.transition = "opacity 0.3s ease-in-out";

    setTimeout(() => {
      element.style.opacity = "1";
    }, 10);
  },
};
